<template>
  <f7-page ptr @ptr:refresh="refreshData" @page:reinit="getList">
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回"
        :back-link-url="`/project/info/${projectId}`">
      </f7-nav-left>
      <f7-nav-title>奖罚通知单</f7-nav-title>
      <f7-nav-right v-if="perms.rewardPunishAdd">
        <f7-link :href="`/rewardPunish/add/${projectId}?flag=add`">填写</f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="has-content-margin">
      <div class="toolbar tabbar">
        <div class="toolbar-inner">
          <a href="#rewardTab" class="tab-link tab-link-active" @click="tabIndex = 0">奖励</a>
          <a href="#punishTab" class="tab-link" @click="tabIndex = 1">处罚</a>
          <span :class="tabIndex == 0? 'tab-link-highlight' : 'tab-link-highlight1'"></span>
        </div>
      </div>
      <div style="height: 1rem;">&nbsp;</div>
      <f7-tabs>
        <f7-tab id="rewardTab" tab-active>
          <div
            class="has-content"
            style="text-align: center;"
            v-if="rewardList.length === 0">
            暂无数据
          </div>
          <div v-else>
            <div>
              <div class="item-head">
                <div class="title-date">
                  日期
                </div>
                <div class="title-text">
                  金额(元)
                </div>
              </div>
            </div>
            <div
              class="item-row"
              v-for="item in rewardList"
              :key="item.id">
              <f7-link :href="`/rewardPunish/add/${projectId}?id=${item.id}`">
                <div class="item-content">
                  <div class="title-date">
                    {{ item.issuanceTime | formatDateValue }}
                  </div>
                  <div class="title-text">
                    {{ item.amount | formatNumberVal }}
                  </div>
                </div>
              </f7-link>
            </div>
          </div>
        </f7-tab>
        <f7-tab id="punishTab">
          <div
            class="has-content"
            style="text-align: center;"
            v-if="punishList.length === 0">
            暂无数据
          </div>
          <div v-else>
            <div>
              <div class="item-head">
                <div class="title-date">
                  日期
                </div>
                <div class="title-text">
                  金额(元)
                </div>
              </div>
            </div>
            <div
              class="item-row"
              v-for="item in punishList"
              :key="item.id">
              <f7-link :href="`/rewardPunish/add/${projectId}?id=${item.id}`">
                <div class="item-content">
                  <div class="title-date">
                    {{ item.issuanceTime | formatDateValue }}
                  </div>
                  <div class="title-text">
                    {{ item.amount | formatNumberVal }}
                  </div>
                </div>
              </f7-link>
            </div>
          </div>
        </f7-tab>
      </f7-tabs>
    </div>
  </f7-page>
</template>
<script>
import currency from 'currency.js';
import { dateFormat } from '@/util/dateUtils';
import { getRewardPunishList } from '@/api/rewardPunish';
import RewardPunish from '@/pages/rewardPunish/add';

export default {
  props: ['projectId'],
  components: {
    RewardPunish,
  },
  data() {
    return {
      rewardPunishList: [],
      tabIndex: 0,
      perms: {},
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    rewardList() {
      return this.rewardPunishList.filter(item => item.type === 'reward');
    },
    punishList() {
      return this.rewardPunishList.filter(item => item.type === 'punish');
    },
  },
  filters: {
    formatDateValue: value => dateFormat(value),
    formatNumberVal: (value) => {
      if (value) {
        return currency(value).format();
      }
      return '--';
    },
  },
  methods: {
    refreshData(event, done) {
      Promise.all([this.getList()]).then(() => done());
    },
    getList() {
      const params = { projectId: this.projectId };
      getRewardPunishList(params).then((result) => {
        if (result.code === 0) {
          this.rewardPunishList = result.data || [];
          this.perms = result.perms || {};
        }
      });
    },
    showRewardPunish(rewardPunish) {
      this.rewardPunish = rewardPunish;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .tab-link-highlight {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 0.2rem;
    background: $theme-color;
    transition-duration: .3s;
    width: 50%;
    transform: translate3d(0%, 0px, 0px);
  }

  .tab-link-highlight1 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 0.2rem;
    background: $theme-color;
    transition-duration: .3s;
    width: 50%;
    transform: translate3d(100%, 0px, 0px);
  }

  .item-row {
    border-bottom: 0.05rem solid $border-color;
    background-color: $white-color;
  }

  .item-head {
    display: flex;
    align-items: center;
    color: $font-color;
    background-color: $panel-bg-color;
  }

  .item-content {
    display: flex;
    align-items: center;
    color: $font-color;
  }

  .title-date {
    width: 50%;
    text-align: center;
    padding: 0.5rem 0.5rem;
  }

  .title-text {
    width: 50%;
    text-align: center;
    padding: 0.5rem 0.5rem;
  }


</style>



// WEBPACK FOOTER //
// src/pages/rewardPunish/list.vue